import { ReactNode } from 'react'
import { Switch } from '../../../Switch'
import s from './styles.module.scss'

export const Disclosure = ({
  isOpen,
  onChange,
  title,
  children,
  disabled,
}: {
  isOpen: boolean
  onChange: (checked: boolean) => void
  title?: string | ReactNode
  children?: ReactNode
  disabled?: boolean
}) => {
  return (
    <div className={s.disclosure}>
      <div className={s.heading}>
        {title}
        <Switch checked={isOpen} onChange={onChange} disabled={disabled} />
      </div>
      {isOpen && <div className={s.content}>{children}</div>}
    </div>
  )
}
